module.exports = __webpack_public_path__ + "img/resource-tech-image-13.738b7dd5.jpg";